"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Label = _interopRequireDefault(require("./Label"));
var _factory = _interopRequireDefault(require("./factory"));
var _default = exports.default = (0, _factory.default)()(_Label.default);